import React, { Component } from 'react'
import { Grid } from '@material-ui/core';
import fire from '../../config/fire'
import CircularProgress from '@material-ui/core/CircularProgress';
import {withRouter} from "react-router-dom"

class Blog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            infos: []
        }
    }

    componentDidMount() {

        let list = []
        fire.database().ref('Blog').once('value', snapshot => {

            snapshot.forEach(snap => {
                list.push(snap.val());
            })

            this.setState({ infos: list })
        })
    }

    render() {

        return (
            <Grid container className="Blog" id="blog" >
                <Grid item xs={12} className="bpHead">
                    <h1>Blog</h1>
                </Grid>
                {
                    this.state.infos.length > 0 ?
                        <div className="body">
                            {
                                this.state.infos.map((info) => {
                                    return (
                                        <div key={info.title} className="body1" style={{ background: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${info.image})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} onClick={() => window.open("/blogs/" + info.title, "_blank")} >
                                            <div className="bgTitle">
                                                <p style={{ fontWeight: 'bold' }}>{info.title}</p>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div> : <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '60px' }}>
                            <CircularProgress thickness={5} />
                        </div>
                }
            </Grid>
        )
    }
}

export default withRouter(Blog)